import * as React from 'react';
import { DillButton } from '../../../general/Dill/DillButton';

export interface StepFormButtonsProps {
  step: number;
  minStep: number;
  maxStep: number;
  onPrevious: () => void;
  onContinue: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  error?: string | null;
}

const StepFormButtons: React.FC<StepFormButtonsProps> = ({
  onContinue,
  onPrevious,
  isLoading,
  isDisabled,
  step,
  minStep,
  maxStep,
  error,
}) => {
  if (minStep === step) {
    return (
      <div className="flex flex-col gap-2 w-full">
        {error && <p className="text-xs text-red-500 text-right">{error}</p>}
        <div className="flex justify-between w-full">
          <div></div>
          <DillButton
            label="Next"
            width={100}
            onClick={onContinue}
            isLoading={isLoading}
            isDisabled={isDisabled || isLoading}
            className="flex justify-center"
          />
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      {error && <p className="text-xs text-red-500 text-right mb-2">{error}</p>}
      <div className="flex justify-between w-full">
        {minStep < step ? (
          <DillButton
            variant="secondary"
            label="Previous"
            width={100}
            onClick={onPrevious}
            isDisabled={isDisabled || isLoading}
            className="flex justify-center"
          />
        ) : (
          <div></div>
        )}
        <DillButton
          label={step === maxStep ? 'Submit' : 'Next'}
          width={100}
          onClick={onContinue}
          isLoading={isLoading}
          isDisabled={isDisabled || isLoading}
          className="flex justify-center"
        />
      </div>
    </React.Fragment>
  );
};

export default StepFormButtons;
